<template>
  <div class="email-modal" @click="closeEmailModal">
    <div class="email-modal__inner" @click.stop="() => {}">
      <div class="email-modal__heading">
        Enter your email address
      </div>
      <div class="email-modal__input">
        <input ref="email" type="email" autofocus v-model="email">
      </div>
      <div class="email-modal__submit">
        <button class="btn btn--email touch" @click="sendEmail">{{ emailButtonValue }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  data() {
    return {
      email: '',
      message: `<p>Thank you for your interest in purchasing a property at Al Mouj Muscat. Please find below a link to view additional information about the property that we discussed today.</p>`,

      isSubmitting: false,
      isSuccess: false,
      isError: false,
    }
  },

  computed: {
    ...mapGetters({
      favourites: 'favourites/favourites',
      language: 'language',
      properties: 'property/properties'
    }),

    emailButtonValue () {
      let value = 'Send'

      if (this.isSubmitting) {
        value = 'Sending...'
      }

      if (this.isSuccess) {
        value = 'Sent!'
      }

      if (this.isError) {
        value = 'Failed'
      }

      return value
    },

    propertyIds () {
      return this.favourites.map(property => property._id).join(',')
    },
  },

  mounted() {

  },

  methods: {
    sendEmail () {
      this.isSubmitting = true
      this.isError = false
      this.isSuccess = false

      axios.post(process.env.VUE_APP_API_HOST + '/favourites/shortlist', { 
        email: this.email,
        propertyIds: this.propertyIds, 
        message: this.message 
      })
      .then(() => {
        this.isSuccess = true
      })
      .catch(() => {
        this.isError = true
        this.isSuccess = false
      })
      .finally(() => {
        this.isSubmitting = false
        this.email = ''

        setTimeout(() => {
          this.closeEmailModal()
        }, 2000);
      })
    },

    closeEmailModal () {
      this.isSubmitting = false
      this.isError = false
      this.isSuccess = false
      this.email = ''
      this.$store.commit('SET_IS_EMAIL_MODAL_ACTIVE', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.email-modal {
  align-items: flex-end;
  background: rgba(0, 0, 0, 0.8);
  bottom: 10rem;
  display: flex;
  justify-content: center;
  left: 0;
  pointer-events: all;
  position: absolute;
  right: 32.5rem;
  top: 0;
  z-index: 100;

  &__inner {
    background: #fff;
    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: 0 0 10rem;
    padding: 2rem 2rem 3rem;
    pointer-events: all;
    width: 50rem;
  }

  &__heading {
    color: #111;
    font-size: 2rem;
    text-align: center;
  }

  &__input {
    width: 100%;

    input {
      border: 0.1rem solid #000;
      border-radius: 0.5rem;
      padding: 1rem;
      pointer-events: all;
      width: 100%;
    }
  }
  &__submit {
    width: 100%;

    .btn--email {
      border: 0.1rem solid #000;
      border-radius: 0.5rem;
      color: #000;
      font-size: 1.2rem;
      margin: 0 0 0 auto;
      padding: 0.5rem 2rem;
    }
  }
}
</style>